import styled, { css } from "styled-components";
import { EpicBreakpointInPx } from "@theme/breakpoint";
import { FontExtensionCSS } from "./fonts-extension";
import { type EpicTypographyExtensionProps } from "./fonts.interface";

/**
 * @deprecated This font should not be used
 */
const DefaultFontCSS = css`
	font-family: Roboto, sans-serif;
	font-weight: 400;
`;

/* H1 */
/**
 * @deprecated This font should not be used
 */
export const EpicH1Typography = css`
	${DefaultFontCSS}
	line-height: 1.625rem;
	font-size: 1.25rem;
	font-weight: 700;
	@media screen and (min-width: ${EpicBreakpointInPx.medium}px) {
		line-height: 1.75rem;
		font-size: 1.375rem;
	}
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicH1Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.H1 ?? EpicH1Typography}
`;

/* H2 */
/**
 * @deprecated This font should not be used
 */
export const EpicH2Typography = css`
	${DefaultFontCSS}
	line-height: 1.25rem;
	font-size: 1rem;
	font-weight: 700;
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicH2Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.H2 ?? EpicH2Typography}
`;

/* H3 */
/**
 * @deprecated This font should not be used
 */
export const EpicH3Typography = css`
	${DefaultFontCSS}
	line-height: 1.25rem;
	font-size: 0.875rem;
	font-weight: 700;
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicH3Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.H3 ?? EpicH3Typography}
`;

/* H4 */
/**
 * @deprecated This font should not be used
 */
export const EpicH4Typography = css`
	${DefaultFontCSS}
	line-height: 1rem;
	font-size: 0.75rem;
	font-weight: 700;
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicH4Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.H4 ?? EpicH4Typography}
`;
/* P1 */
/**
 * @deprecated This font should not be used
 */
export const EpicP1Typography = css`
	${DefaultFontCSS}
	line-height: 1.75rem;
	font-size: 1rem;
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicP1Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.P1 ?? EpicP1Typography}
`;

/* P2 */
/**
 * @deprecated This font should not be used
 */
export const EpicP2Typography = css`
	${DefaultFontCSS}
	line-height: 1.375rem;
	font-size: 0.875rem;
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicP2Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.P2 ?? EpicP2Typography}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicP2Anchor = styled.a<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.P2 ?? EpicP2Typography}
`;

/* P3 */
/**
 * @deprecated This font should not be used
 */
export const EpicP3Typography = css`
	${DefaultFontCSS}
	line-height: 1.125rem;
	font-size: 0.75rem;
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicP3Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.P3 ?? EpicP3Typography}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicP3Label = styled.label<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.P3 ?? EpicP3Typography}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicP3Anchor = styled.a<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.P3 ?? EpicP3Typography}
`;

/* L1 */
/**
 * @deprecated This font should not be used
 */
export const EpicL1Typography = css`
	${DefaultFontCSS}
	line-height: 0.625rem;
	font-size: 0.625rem;
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicL1Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.L1 ?? EpicL1Typography}
`;

/* B1 */
/**
 * @deprecated This font should not be used
 */
export const EpicB1Typography = css`
	${DefaultFontCSS}
	line-height: 1rem;
	font-size: 0.875rem;
	${FontExtensionCSS}
`;
/**
 * @deprecated This font should not be used
 */
export const EpicB1Span = styled.span<EpicTypographyExtensionProps>`
	${({ theme }) => theme.fonts?.B1 ?? EpicB1Typography}
`;
